var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagIcon = function SvgTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2999_477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49001 6.53801L3.41901 10.838C2.92201 11.533 2.92201 12.468 3.41901 13.163L6.49001 17.463C6.86501 17.988 7.47101 18.3 8.11701 18.3H19C20.105 18.3 21 17.405 21 16.3V7.70001C21 6.59501 20.105 5.70001 19 5.70001H8.11701C7.47101 5.70001 6.86501 6.01201 6.49001 6.53801Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2999_477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgTagIcon as ReactComponent };
export default __webpack_public_path__ + "tag-icon.svg";